export function scrollAnchors() {
  $('a[href^="#"]').click(function(e){
    e.preventDefault();
    let anchor = $(this).attr('href')
    if(anchor!=="#") {
      const header = $('.header').outerHeight();
      if(anchor=="#below") { anchor = ".hero + *"; }
      $([document.documentElement, document.body]).animate({
        scrollTop: $(anchor).offset().top - header - 100,
      }, 500);
    }
  })
}
